import React, { useEffect } from 'react';
import { useAuth } from '@/hooks';
import { authEvents } from '@/services/authEvents';
import { useNavigate } from 'react-router-dom';

/**
 * Component to handle authentication events and refresh permissions
 */
export const AuthEventListener: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { refreshUserPermissions, state } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleRefreshPermissions = async () => {
      console.log('Refreshing user permissions due to 403 response...');
      try {
        await refreshUserPermissions();
        console.log('User permissions refreshed successfully');
      } catch (error) {
        console.error('Failed to refresh permissions:', error);
        // The auth context will handle setting the appropriate state
      }
    };

    const handleLogout = () => {
      console.log('Handling logout event');
      navigate('/login');
    };

    // Subscribe to auth events
    authEvents.on('refreshPermissions', handleRefreshPermissions);
    authEvents.on('logout', handleLogout);

    // Cleanup
    return () => {
      authEvents.off('refreshPermissions', handleRefreshPermissions);
      authEvents.off('logout', handleLogout);
    };
  }, [refreshUserPermissions, navigate, state]);

  return <>{children}</>;
};
